<template>
  <div class="image-text-nav-selector">
    <div class="item-setting">
      <div class="header-setting">
        <div class="header-setting__tip">最多添加 20 个导航，拖动选中的导航可对其排序</div>
      </div>
      <div class="tips">特别提示：商品模式为常规情况下请放在最下方，切勿与商品列表模块重复使用！</div>
      <div class="body-setting">
        <tabs-editor
          v-model="$$FormData.tabsList"
          :limit="20"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabsModuleSelector'
}
</script>

<style lang="scss" scoped>
.tips {
  padding: 0 16px 12px 16px;
  color: red;
  font-size: 12px;
  line-height: 18px;
}
</style>